const projectSearchExtraFields = {
  guests: ['main_image', 'main_tag', 'owner', 'partnerships', 'avatar_image'],
  users: ['user_role'],
}

export const projectSearchFieldsForGuests = projectSearchExtraFields.guests
export const projectSearchFieldsForUsers = [...projectSearchExtraFields.guests, ...projectSearchExtraFields.users]
